import script from "./ModalAccountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAccountDetails.vue?vue&type=script&setup=true&lang=js"

import "./ModalAccountDetails.vue?vue&type=style&index=0&id=0ed1ad32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed1ad32"]])

export default __exports__